<template xmlns="http://www.w3.org/1999/html">
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="position: fixed;">
                <div class="page-name" style="width:40%">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content" style="padding-top: 100px;">
                <!--Forms-->

                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">

                        <!-- Parts -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Parts :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="partId"
                                          name="partId"
                                          id="partId"
                                          label="name"
                                          :filterable="true"
                                          :options="partOption"
                                          @input="onChnagePart()"
                                          placeholder="Select Part">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{partError}}</span>
                            </div>
                        </div>

                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Bin Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="binLocation" placeholder="Enter Bin Location" v-model="binLocation">
                                <span class="text-danger">{{binLocationError}}</span>
                            </div>
                        </div>

                        <!--Blank Div-->
                        <div class="col-6 forms-block">
                          <div class="col-3 paddingleft0">
                            <div class="form-label"> Max Qty : </div>
                          </div>

                          <div class="col-9 paddingleft0">
                            <button class="btn btn-primary" v-on:click.prevent="minusMaxQty()">
                              <i class="fa fa-minus"></i>
                            </button>
                            <input  id="max_qty" placeholder="Enter Max Qty" v-model="maxQty">
                            <button class="btn btn-primary" v-on:click.prevent="plusMaxQty()">
                              <i class="fa fa-plus"></i>
                            </button>
                            <div class="requiredstar">*</div>
                            <br/>
                            <span class="text-danger">{{maxQtyError}}</span>
                          </div>

                        </div>

                        <!--Qty-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Qty : </div>
                            </div>

                            <div class="col-9 paddingleft0">
                                <button class="btn btn-primary" v-on:click.prevent="minusQty()">
                                    <i class="fa fa-minus"></i>
                                </button>
                                <input  id="qty" placeholder="Enter Qty" v-model="qty">
                                <button class="btn btn-primary" v-on:click.prevent="plusQty()">
                                    <i class="fa fa-plus"></i>
                                </button>
                                <div class="requiredstar">*</div>
                                <br/>
                                <span class="text-danger">{{qtyError}}</span>
                            </div>
                        </div>

                        <!--Threshold Qty-->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Threshold Qty : </div>
                            </div>

                            <div class="col-9 paddingleft0">
                                <button class="btn btn-primary" v-on:click.prevent="minuThresholdQty()">
                                    <i class="fa fa-minus"></i>
                                </button>
                                <input id="thresholdQty" placeholder="Enter Threshold Qty" v-model="thresholdQty">
                                <button class="btn btn-primary" v-on:click.prevent="plusThresholdQty()">
                                    <i class="fa fa-plus"></i>
                                </button>
                                <div class="requiredstar">*</div>
                                <br/>
                                <span class="text-danger">{{thresholdQtyError}}</span>
                            </div>
                        </div> -->

                    </div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary mt-2" v-on:click.prevent="addInventoryParts()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary mt-2" v-on:click.prevent="addInventoryParts (flag='Save and Continue')">
                        <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addInventoryParts ()"></input>-->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary mt-2" v-on:click.prevent="buttonBack">
                    </div>

                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';

    var moment = require('moment-timezone');

    export default {
        name: 'addUpdateInventoryParts',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Add Inventory Parts",

                partId: {
                    'name' : "",
                    'id' : "",
                },
                partOption : [],
                partError : "",

                qty : 0,
                maxQty : 0,
                maxQtyError : "",
                qtyError : "",
                thresholdQty : 0,
                thresholdQtyError : "",

                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                inventoryId : 0,
                binLocation: "",
                binLocationError: "",
                customerId:0,
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("customer-menu-selection-changed", "list-inventory");
        },

        watch: {

        },
        mounted: function () {
            // EventBus.$emit('showHeader', true);

            $("#alertError").hide();
            self.removeErrorMessageOnInput();

            if (self.$route.params.inventory_id > 0) {
                self.inventoryId = self.$route.params.inventory_id;
            }

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3] == 'update-inventory-part') {
                //if (segments[5]) {
                    self.getInventoryPartDetailById()
                    self.buttonNames.save = "Update";
                    $("#addAndContinueBenifitBtn").hide();
                    // $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit Inventory Part";
                    $(".requiredstarPassword").hide();
                    $(".requiredstarConfirmPassword").hide();
                //}
            } else {
                $(".requiredstarPassword").show();
                $(".requiredstarConfirmPassword").show();
            }

            self.getAllPartList();
            // self.getInventoryPartDetailById();
        },
        beforeDestroy(){
            // EventBus.$off('all-permissions');
        },
        methods: {
            plusQty : function() {
                self.qty++;
                self.qtyError = "";
            },
            minusQty : function() {
                if (self.qty > 0) {
                    self.qty--;
                    self.qtyError = "";
                }
            },
            plusMaxQty : function() {
                self.maxQty++;
                self.maxQtyError = "";
            },
            minusMaxQty : function() {
                if (self.maxQty > 0) {
                    self.maxQty--;
                    self.maxQtyError   = "";
                }
            },
            plusThresholdQty : function () {
                self.thresholdQty++;
                self.thresholdQtyError = "";
            },
            minuThresholdQty : function () {
                if (self.thresholdQty > 0) {
                    self.thresholdQty--;
                    self.thresholdQtyError = "";
                }

            },
            getAllPartList : function () {
                var self = this;
                var config = {
                    //headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get('part-list', config)
                    .then(function (response) {
                        //console.log('getAllLocationList', response);
                        if (response.status == '200') {
                            self.partOption = response.data.part
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },

            removeErrorMessageOnInput : function () {
                /* Remove error on input */
                $("#max_qty").keyup(function () {
                    self.maxQtyError = "";
                });

                $("#qty").keyup(function () {
                    self.qtyError = "";
                });

                $("#thresholdQty").keyup(function () {
                    self.thresholdQtyError = "";
                });
                
                $("#binLocation").keyup(function () {
                    self.binLocationError = "";
                });
            },

            showAlertOnSave : function (alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },

            buttonBack : function () {
                if (self.$route.params.customer_id > 0) {
                    self.$router.push('/list-customer-inventory/' + self.$route.params.customer_id);
                } else {
                    self.$router.push('/list-customer-inventory/' + self.customerId);
                }
            },
            onChnagePart : function () {
                self.partError = "";
            },
            clearDataOnSaveAndContinue : function () {
                self.qty = 0;
                self.maxQty = 0;
                self.thresholdQty = 0;
                self.partId = {
                    'id' : "",
                    'name' : "",
                };
                self.binLocation = "";
            },

            onChnageTimezone : function () {
                self.timezoneError = "";
            },

            checkForm: function () {
                var checked = true;

                if (self.maxQty <= 0) {
                    self.maxQtyError = "Please enter valid Max Qty";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.allnumeric(self.maxQty)) {
                    self.maxQtyError = "Only Number Allowed";
                    if (checked) {
                        checked = false;
                    }
                }

                if(self.allnumeric(self.maxQty) && self.maxQty > 1000) {
                    self.maxQtyError = "Max Qty must be less than 1000";
                    if (checked) {
                        checked = false;
                    } 
                }

                if (self.qty < 0) {
                    self.qtyError = "Please enter valid Qty";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.allnumeric(self.qty)) {
                    self.qtyError = "Only Number Allowed";
                    if (checked) {
                        checked = false;
                    }
                }

                if(self.allnumeric(self.qty) && self.qty > 1000) {
                    self.qtyError = "Qty must be less than 1000";
                    if (checked) {
                        checked = false;
                    } 
                }

                /* if (self.thresholdQty <= 0) {
                    self.thresholdQtyError = "Please enter valid Threshold Qty";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.allnumeric(self.thresholdQty)) {
                    self.thresholdQtyError = "Only Number Allowed";
                    if (checked) {
                        checked = false;
                    }
                }

                if(self.allnumeric(self.thresholdQty) && self.thresholdQty > 1000) {
                    self.thresholdQtyError = "Threshold Qty must be less than 1000";
                    if (checked) {
                        checked = false;
                    } 
                } */

                if (self.partId == null || !self.partId.id || self.partId.id === 0) {
                    self.partError = "Part Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if(parseInt(self.qty) > parseInt(self.maxQty)) {
                    self.qtyError = "Qty Should not be greater than Max Qty";
                    if (checked) {
                        checked = false;
                    } 
                }
                if (self.binLocation && self.binLocation.length > 15) {
                    self.binLocationError = "Bin Location must be less than 15 Characters";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },

            allnumeric : function (inputtxt) {
                var numbers = /^\d+$/;;
                if(numbers.test(inputtxt)) {
                    return true;
                } else {
                    return false;
                }
            },

            getInventoryPartDetailById: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    inventory_id: self.inventoryId,
                    id: self.$route.params.id,
                };

                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };

                HTTP.post('/inventory-part-details-by-id', fields, config)
                    .then(response => {
                        self.pageTitle = "Edit '" + response.data.content.inventory_name + "' Part";
                        self.maxQty = response.data.content.max_qty;
                        self.qty = response.data.content.qty;
                        self.thresholdQty = response.data.content.threshold_qty;
                        self.binLocation = response.data.content.bin_location;
                        self.customerId = response.data.content.inventory_customer_id;

                        self.partId = {
                            'id' : response.data.content.part_id,
                            'name' : response.data.content.part_name,
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },

            addInventoryParts (flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var config = {
                            headers: {
                                Authorization:localStorage.getItem("access_token")
                            }
                        };

                        if (segments[3] == 'update-inventory-part') {
                            if (segments[4]) {
                                var data = {
                                    qty: self.qty,
                                    max_qty: self.maxQty,
                                    threshold_qty: self.thresholdQty,
                                    part_id : self.partId.id,
                                    inventory_id : self.inventoryId,
                                    bin_location : self.binLocation,
                                    inventory_part_id: segments[4],
                                };
                                self.buttonNames.save = "Updating ...";
                                self.disableButtons.save = true;
                                self.disableButtons.cancel = true;
                            } else {
                                if (flag == "Save and Continue") {
                                    self.buttonNames.saveAndContinue = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                } else {
                                    self.buttonNames.save = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                }
                            }
                        } else {
                            var data = {
                                qty: self.qty,
                                max_qty: self.maxQty,
                                threshold_qty: self.thresholdQty,
                                part_id : self.partId.id,
                                inventory_id : self.inventoryId,
                                bin_location : self.binLocation,
                            };
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }

                        HTTP.post("/add-update-inventory-parts", data, config)
                            .then(function (response) {
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if (segments[1] == 'update-customer') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    if (segments[2]) {
                                        self.buttonNames.save = "Update";
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                        } else {
                                            self.buttonNames.save = "Save";
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.user_message);
                                    //self.showAlertOnSave(response.data.user_message, "success");
                                    self.showSAlert(response.data.user_message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                if (segments[1] == 'update-customer') {
                                    if (segments[2]) {
                                        self.buttonNames = "Update";
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                            self.clearDataOnSaveAndContinue();
                                        } else {
                                            self.buttonNames.save = "Save";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                            });
                    }
                }, 200);
            },
        }

    }

</script>

<style>
    .field-icon {
        float: right;
        margin-right: 8px;
        margin-top: -23px;
        position: relative;
        z-index: 2;
        cursor:pointer;
    }

    .container{
        padding-top:50px;
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Inventory/AddUpdateInventoryPart.vue